module.exports = __webpack_public_path__ + "static/media/01.0ade8f38.mp3";